import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as Edit } from 'Assets/controls/framed-edit.svg';
import { Input } from 'antd';
import type { InputRef } from 'antd';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { TitleWithIcon } from 'Components/TitleWithIcon/TitleWithIcon';
import styles from './Rates.module.scss';

type RatesProps = {
  handleRateInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  brokerRate: number;
  driverRate: number;
};

export const Rates: React.FC<RatesProps> = ({
  handleRateInput: inputRateHandler,
  brokerRate,
  driverRate,
}) => {
  const [ratesInputsActive, setRatesInputsActive] = useState(false);
  const [titleIconVisibility, setTitleIconVisibility] = useState(true);
  const inputRef = useRef<InputRef>(null);
  const ratesIconHandler = () => {
    if (!ratesInputsActive) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus({
            cursor: 'end',
          });
        }
      }, 100);
    }

    setRatesInputsActive(!ratesInputsActive);
  };
  const currentBid = useSelector(selectCurrentOrder);

  useEffect(() => {
    if (
      currentBid &&
      !currentBid.order_status.toLowerCase().includes('await')
    ) {
      setTitleIconVisibility(false);
      setRatesInputsActive(false);
    }
  }, [currentBid]);

  return (
    <div className={styles.rates}>
      <TitleWithIcon
        content="Rates"
        icon={Edit}
        iconTitle="Edit bid rates"
        iconClickHandler={ratesIconHandler}
        iconVisibility={titleIconVisibility}
      />
      <table className={styles.rates__table}>
        <thead className={styles.rates__thead}>
          <tr>
            <th className={styles.rates__thead__cell}>Broker</th>
            <th className={styles.rates__thead__cell}>Driver</th>
            <th className={styles.rates__thead__cell}>Revenue</th>
          </tr>
        </thead>
        <tbody className={styles.rates__tbody}>
          <tr>
            <td className={styles.rates__tbody__cell}>
              {ratesInputsActive ? (
                <Input
                  className={styles.rates__input}
                  value={brokerRate}
                  size="small"
                  name="broker"
                  onChange={(event) => inputRateHandler(event)}
                  ref={inputRef}
                />
              ) : (
                `${brokerRate}$`
              )}
            </td>
            <td className={styles.rates__tbody__cell}>
              {ratesInputsActive ? (
                <Input
                  className={styles.rates__input}
                  value={driverRate}
                  size="small"
                  name="driver"
                  onChange={(event) => inputRateHandler(event)}
                />
              ) : (
                `${driverRate}$`
              )}
            </td>
            <td className={styles.rates__tbody__cell}>
              {brokerRate > driverRate ? brokerRate - driverRate + '$' : '0$'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
